import { loader } from '@monaco-editor/react';
import { StyledEngineProvider } from '@mui/material';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import * as monaco from 'monaco-editor';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import hljs from 'highlight.js';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.snow.css';
import Application from './application/Application';
import ApplicationRouter from './application/ApplicationRouter';
import { ConfigLoader } from './application/config/ConfigLoader';
import I18nProvider from './application/language/LocalizationProvider';
import ApplicationTheme from './application/theme/ApplicationTheme';
import ErrorBundary from './common/errorPage/ErrorBoundary/ErrorBundary';
import * as serviceWorker from './serviceWorker';
// @ts-ignore
window.hljs = hljs;

export const cacheDb: IDBOpenDBRequest = indexedDB.open('cache', 1);

loader.config({ monaco });
LicenseInfo.setLicenseKey(
  '5e1fb774e91661f07d229563cb03e09aTz0xMTI5MjksRT0xNzc4ODAzMTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
);

ReactDOM.render(
  <Suspense fallback={<div>Loading...</div>}>
    <I18nProvider>
      <StyledEngineProvider injectFirst>
        <ApplicationTheme>
          <ErrorBundary>
            <Application>
              <ConfigLoader>
                <ApplicationRouter />
              </ConfigLoader>
            </Application>
          </ErrorBundary>
        </ApplicationTheme>
      </StyledEngineProvider>
    </I18nProvider>
  </Suspense>,
  document.getElementById('root'),
);

serviceWorker.registerSW();
